import { useState } from "react";
import { cn } from "@/lib/utils";

export function Avatar({
  name,
  initials,
  photoUrl,
  size = 40,
  className,
}: {
  name?: string | null;
  initials?: string | null;
  photoUrl?: string | null;
  size?: number;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  const fallback = (initials || (name ?? "?").split(" ").map((p) => p[0]).filter(Boolean).slice(0, 2).join("")).toUpperCase() || "?";
  const showImg = photoUrl && !failed;
  return showImg ? (
    <img
      src={photoUrl!}
      alt={name ?? ""}
      onError={() => setFailed(true)}
      style={{ width: size, height: size }}
      className={cn("rounded-full object-cover bg-white/5", className)}
    />
  ) : (
    <span
      style={{ width: size, height: size, fontSize: Math.max(10, Math.round(size * 0.32)) }}
      className={cn(
        "grid place-items-center rounded-full bg-gradient-to-br from-primary/30 to-primary/10 font-medium text-foreground/90 hairline",
        className,
      )}
    >
      {fallback}
    </span>
  );
}